import Button from '../Button';
import Lucide from '../Lucide';

const ErrorFallback = () => {
  return (
    <div className='min-h-screen w-full text-slate-900 flex items-center justify-center p-6'>
      <div className='w-full max-w-lg rounded-xl border border-border p-8 shadow-sm'>
        <p className='text-xs font-semibold uppercase tracking-wider text-slate-500'>
          Something went wrong
        </p>
        <h1 className='mt-2 text-2xl font-bold text-primary'>
          We hit an unexpected error
        </h1>
        <p className='mt-3 text-sm leading-6'>
          Our team has been notified. Please refresh this page. If the problem
          continues, contact support.
        </p>
        <Button
          type='button'
          onClick={() => window.location.reload()}
          variant='primary'
          className='mt-6'
        >
          <Lucide icon='RefreshCcw' className='mr-2' /> Reload page
        </Button>
      </div>
    </div>
  );
};

export default ErrorFallback;
